import { ThemeType } from 'theme/jss-types';
import { commonStyleSheet } from '../../library/common-styles';
import { ZIndex } from 'library/constants';

export const serviceAvailabilityStyles = (theme: ThemeType) => ({
    ...commonStyleSheet(theme),
    main: {
        fontFamily: 'Open Sans',
        padding: '12px 16px',
        letterSpacing: 0,
        '& .ant-drawer-header': {
            padding: 12,
        },
        '& .ant-drawer-body': {
            backgroundColor: '#FFF',
            alignSelf: 'center',
            padding: '12px 16px',
            width: '100%',
        },
        '& .ant-btn-primary': {
            borderRadius: 4,
            marginRight: 8,
            color: '#FFFFFF',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            letterSpacing: 0,
            height: 32,
            fontSize: 12,
        },
        maxHeight: '100vh',
        overflow: 'scroll',
        zIndex: ZIndex.forms,
    },
    header: {
        ...commonStyleSheet(theme).flexRow,
        width: '100%',
        justifyContent: 'space-between',
        padding: 0,
    },
    addText: {
        ...commonStyleSheet(theme).flexRow,
        color: '#000000',
        fontWeight: 600,
        letterSpacing: 0,
        fontFamily: 'Open Sans',
        fontSize: 20,
    },
    closeIcon: {
        marginRight: 8,
        cursor: 'pointer',
        color: '#000000',
        letterSpacing: 0,
        fontFamily: 'Open Sans',
        fontWeight: 600,
        fontSize: 16,
    },
    inputs: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingTop: 16,
        paddingRight: theme.isRTL ? undefined : '10%',
        paddingLeft: theme.isRTL ? '10%' : undefined,
    },
    input: {
        width: '40%',
    },
    availableText: {
        color: '#232529',
        fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeight: 600,
    },
    body: {
        padding: 24,
        paddingBottom: 8,
    },
    serviceName: {
        color: '#232529',
        fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeight: 500,
        letterSpacing: 0,
    },
    value: {
        color: '#777777',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
    },
    nameValuePair: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'space-between',
        margin: 12,
        marginLeft: 0,
        marginRight: '10%',
    },
    name: {
        color: '#777777',
        fontFamily: 'Open Sans',
        fontWeight: 600,
        fontSize: 12,
        letterSpacing: 0,
        marginBottom: 5,
        display: 'flex',
    },
    serviceableTatPair: {
        display: 'flex',
        margin: 12,
        marginLeft: 0,
        marginRight: '10%',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    hr: {
        width: '92%',
        height: 1,
        marginLeft: '4%',
        backgroundColor: '#CCCCCC',
    },
    services: {
        ...commonStyleSheet(theme).flexColumn,
        backgroundColor: '#FCFCFC',
        padding: 16,
        border: '1px solid #DDDFE9',
        height: 'fit-content',
        '& div.ant-typography': {
            margin: '0px !important',
        },
    },
    heading: {
        alignItems: 'normal',
        boxSizing: 'border-box',
        borderRadius: 4,
        width: '100%',
    },
    headingTitle: {
        fontSize: 18,
        color: '#333333',
        fontWeight: 'bold',
        width: '100%',
    },
    subHeading: {
        fontSize: 14,
        fontWeight: 600,
        fontFamily: 'Open Sans',
        color: '#232529',
        marginBottom: 10,
    },
    pincodeBox: {
        backgroundColor: '#FCFCFC',
        padding: 12,
        border: '1px solid #DDDFE9',
        height: 'fit-content',
        marginBottom: 10,
        '& div.ant-typography': {
            margin: '0px !important',
        },
    },
    expandIcon: {
        fontSize: 22,
        cursor: 'pointer',
        color: '#777777',
        backgroundColor: '#F7F7F7',
        borderRadius: '4px',
        padding: '2px',
        marginLeft: '8px',
    },
    checkboxGroup: {
        margin: '10px 0',
        color: '#333333',
        fontSize: 12,
        fontWeight: 500,
    },
    checkbox: {
        width: 25,
        marginRight: 5,
        marginLeft: 5,
        '& .ant-checkbox-checked .ant-checkbox-inner': {
            backgroundColor: theme.primaryColor,
            borderColor: theme.primaryColor,
        },
        '& .ant-checkbox + span': {
            width: '100%',
        },
    },
    submitButton: {
        backgroundColor: theme.primaryColor,
        color: '#FFFFFF',
        fontSize: 12,
        fontWeight: 600,
        cursor: 'pointer',
    },
    singleInfoDesc: {
        ...commonStyleSheet(theme).flexRow,
        alignItems: 'center',
        borderRadius: 4,
        width: '100%',
        backgroundColor: '#FAFDFF !important',
        border: 'none !important',
        paddingBottom: 8,
        margin: '0 !important',
    },
    singleInfoDescIcon: {
        fontSize: 24,
        paddingRight: 10,
        color: theme.primaryColor,
    },
    singleInfoDescText: {
        fontSize: 12,
        color: '#333333',
        fontWeight: 500,
    },
    singleInfoCheck: {
        fontSize: 12,
        fontWeight: 600,
    },
    tags: {
        padding: 16,
        '& .ant-tag': {
            fontSize: 14,
            color: '#777777',
            backgroundColor: '#F7F7F7',
            fontWeight: 600,
            padding: '4px 8px',
            borderRadius: 4,
            border: 'none',
        },
    },
    singleField: {
        ...commonStyleSheet(theme).flexColumn,
        margin: '0px 4px',
        width: '48%',
    },
    pincodeInput: {},
    pincodeValidation: {
        ...commonStyleSheet(theme).flexRow,
        color: '#52C14B',
        fontSize: 12,
        fontFamily: 'Open Sans',
        letterSpacing: 0,
        fontWeight: 600,
    },
    fields: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'space-between',
        padding: '8px 0',
    },
});
